module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGcbee947f362182dfa9eeabdf7688e5b3.cbee947f.png";